import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'
import { BaseService } from './base'

class Comments {
  get(id, params) {
    const url = `${
      APIPath.commentsByVideo
    }/${id}?${CommonUtility.objectToParams(params)}`
    return BaseService.get(url)
  }

  flagged(params) {
    const url = `${APIPath.adminFlaggedVideos}?${CommonUtility.objectToParams(
      params,
    )}`
    return BaseService.get(url)
  }

  flaggedComment(flag_status,filter) {
    const url = `${APIPath.flaggedComment}?flag_status=${flag_status}&${CommonUtility.objectToParams(
      filter,
    )}`
    return BaseService.get(url)
  }

  resolveFlaggedComment(data) {
    const url = `${APIPath.commentAdmin}/resolve`
    return BaseService.put(url,data)
  }

  blockFlaggedComment(id,data) {
    const url = `${APIPath.commentAdmin}/${id}/toggle-block`
    return BaseService.put(url,data)
  }

}

// Initialize the service with the desired API path
const CommentsService = new Comments()
Object.freeze(CommentsService)

export { CommentsService }
